import { render, staticRenderFns } from "./ServicePointCard.vue?vue&type=template&id=6e325ff6"
import script from "./ServicePointCard.vue?vue&type=script&lang=ts"
export * from "./ServicePointCard.vue?vue&type=script&lang=ts"
import style0 from "./ServicePointCard.vue?vue&type=style&index=0&id=6e325ff6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports